<app-tablepage-base [loading]="loading">

  <!-- 1. LA TABELLA (Dichiarata semplicemente con scrollHeight="100%") -->
  <p-table [value]="organizations"
           [paginator]="true" [rows]="25"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['organizationId', 'name']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listOrganizations' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
          <p-button variant="outlined" icon="pi pi-warehouse" [label]="'newOrg' | translate" (click)="onShowDialog(newOrganization)" />
          <p-button variant="outlined" icon="pi pi-download" label="Download CSV" (click)="exportToCSV(dt,true)" />
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>ID</th>
        <th>{{ 'name' | translate }}</th>
        <th style="width:10%"></th>
      </tr>
    </ng-template>
    <ng-template #body let-organization>
      <tr [pSelectableRow]="organization">
        <td>{{ organization.organizationId }}</td>
        <td>{{ organization.name }}</td>
        <td>
          <p-button icon="pi pi-file-edit" (click)="onShowDialog(organization)" />
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- 2. DIALOG (Posizionata fuori dal flusso, non rompe il layout) -->
  <app-organization-dialog [isNew]="isNew"
                           [messageService]="messageService"
                           [(visible)]="showDialog"
                           [organization]="selectedOrganization"
                           (saved)="onOrganizationSaved($event)">
  </app-organization-dialog>
</app-tablepage-base>
